/**
 * Workspace experience modes — UX only, not auth roles.
 * @see reference_docs/aariyatalk-ux-kit.html
 * @see reference_docs/frontend-ux-evolution-plan.md
 */

export const WORKSPACE_MODES = ['business', 'builder', 'agency', 'enterprise'];

export const WORKSPACE_LABELS = {
  business: 'Business',
  builder: 'Builder / Developer',
  agency: 'Agency',
  enterprise: 'Enterprise',
};

export const STORAGE_KEYS = {
  experience: 'aariyatalk_workspace_experience',
  showDeveloperTools: 'aariyatalk_show_developer_tools',
};

export const DEFAULT_WORKSPACE = 'business';

/** Nav item ids — stable keys for visibility rules */
export const NAV_IDS = {
  dashboard: 'dashboard',
  voipCalling: 'voip-calling',
  telephony: 'telephony',
  agents: 'agents',
  knowledge: 'knowledge',
  testing: 'testing',
  analytics: 'analytics',
  callLogs: 'call-logs',
  integrations: 'integrations',
  settings: 'settings',
  mcp: 'mcp',
  develop: 'develop',
  workflows: 'workflows',
  sales: 'sales',
  payment: 'payment',
  docs: 'docs',
};

/**
 * Default nav visibility per workspace (before showDeveloperTools override).
 * Developer-only ids: develop, mcp (mcp also reachable via integrations).
 */
export const NAV_VISIBILITY = {
  business: new Set([
    NAV_IDS.dashboard,
    NAV_IDS.voipCalling,
    NAV_IDS.telephony,
    NAV_IDS.agents,
    NAV_IDS.knowledge,
    NAV_IDS.workflows,
    NAV_IDS.sales,
    NAV_IDS.callLogs,
    NAV_IDS.integrations,
    NAV_IDS.settings,
    NAV_IDS.payment,
    NAV_IDS.docs,
    NAV_IDS.testing,
    NAV_IDS.analytics,
  ]),
  builder: new Set(Object.values(NAV_IDS)),
  agency: new Set([
    NAV_IDS.dashboard,
    NAV_IDS.agents,
    NAV_IDS.knowledge,
    NAV_IDS.workflows,
    NAV_IDS.sales,
    NAV_IDS.integrations,
    NAV_IDS.callLogs,
    NAV_IDS.voipCalling,
    NAV_IDS.telephony,
    NAV_IDS.testing,
    NAV_IDS.analytics,
    NAV_IDS.settings,
    NAV_IDS.payment,
    NAV_IDS.docs,
    NAV_IDS.mcp,
    NAV_IDS.develop,
  ]),
  enterprise: new Set(Object.values(NAV_IDS)),
};

/** Developer tools unlocked in business mode when user opts in */
export const DEVELOPER_NAV_IDS = new Set([NAV_IDS.develop, NAV_IDS.mcp]);

export function isValidWorkspace(mode) {
  return WORKSPACE_MODES.includes(mode);
}

export function isNavVisibleForWorkspace(navId, workspace, showDeveloperTools) {
  const allowed = NAV_VISIBILITY[workspace] || NAV_VISIBILITY.business;
  if (allowed.has(navId)) return true;
  if (showDeveloperTools && DEVELOPER_NAV_IDS.has(navId)) return true;
  return false;
}
